module.exports = __webpack_public_path__ + "img/Hands-Down-icon.479dd1f6.png";